import axios from 'axios'
import { CustomException } from '../utils/exceptions'

export const getTypeForfaitTransport = async () => {
  const typeForfait = await axios.get('/service/typeForfaitTransport')
    .catch((e) => {
      throw new CustomException(e, 'Error fetching typeForfait')
    })
  return typeForfait.data
}

export const postTypeForfaitTransport = async typeForfait => {
  const typeForfaitResponse = await axios.post('/service/setTypeForfaitTransport', typeForfait)
    .catch((e) => {
      throw new CustomException(e, 'Error posting typeForfait')
    })
  return typeForfaitResponse.data
}
